import { useEffect, useState } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Header } from "@/components/Header";
import { CategoryHero } from "@/components/CategoryHero";
import { CategorySection } from "@/components/CategorySection";
import { Stats } from "@/components/Stats";
import { Features } from "@/components/Features";
import { Reviews } from "@/components/Reviews";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { api } from "@/lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState({ brand_name: "LUXOR", whatsapp_number: "4915510160416", logo_image: "/logo.jpg", injectable_image: "/injectable.webp", oral_image: "/oral.webp", telegram_link: "", announcement_text: "", site_description: "" });

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const injectable = products.filter((p) => p.category === "injectable");
  const oral = products.filter((p) => p.category === "oral");

  return (
    <SmoothScroll>
      <AnnouncementBar text={settings.announcement_text} />
      <Header brand={settings.brand_name} logo={settings.logo_image} />
      <div className="h-[116px]" aria-hidden />
      <main>
        <CategoryHero injectableImg={settings.injectable_image} oralImg={settings.oral_image} />
        <CategorySection id="injectable" index="01" label="Catalog" title="Injectable" description="" products={injectable} />
        <CategorySection id="oral" index="02" label="Catalog" title="Oral" description="" products={oral} />
        <Stats />
        <Features />
        <Reviews />
      </main>
      <Footer brand={settings.brand_name} whatsappNumber={settings.whatsapp_number} logo={settings.logo_image} telegramLink={settings.telegram_link} description={settings.site_description} />
      <CartDrawer whatsappNumber={settings.whatsapp_number} />
      <WhatsAppFloat whatsappNumber={settings.whatsapp_number} telegramLink={settings.telegram_link} />
    </SmoothScroll>
  );
}
